import React from "react";
import { Col, Row } from "react-bootstrap";
import "../../../screens/auth/login/login.css";
import { dentalIcons } from "../../../dentail-indetifcation/utils-icons/dentalIcons";

function AuthScreensLayout({ children }) {
  return (
    <div className="login_container">
      <Row>
        <Col xs={12} md={12} lg={6}>
          {children}
        </Col>
        <Col md={6}>
          <div className="hidden lg:block">
            <div className="right_side_content">
              <div className="right_side_content_body">
                <div className="right_side_content_title">
                  <span>Forensic Dental Tool</span>
                </div>
                <p className="right_side_content_heading">
                  Streamline your forensic workflows for faster, more accurate
                  age and{" "}
                  <span className="right_side_content_sub_heading">
                    identity assessments
                  </span>
                </p>
                <img src={dentalIcons.rightSideNew} alt="showcase" />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default AuthScreensLayout;
